<template>
    <div id="challengeHistortyPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('challenge.history_popup_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div v-if="data.length > 0" class="row">
                        <div class="col-8 pl-5">{{ $t('challenge.history_popup_name_tab') }}</div>
                        <div class="col-4">{{ $t('challenge.history_popup_score_tab') }}</div>
                    </div>

                    <ul v-if="data.length > 0" class="dataList">
                        <li v-for="(d, index) in data" :key="index" :class="d.type.design"> 
                            <span>{{ index + 1 }}.</span>
                            <div class="user d-flex align-items-center">
                                <img v-if="isMeChallenger(d)" :src="d.challengee.avatarUrl != undefined ? d.challengee.avatarUrl : '/images/male-default.png'"/>
                                <img v-else :src="d.challenger.avatarUrl != undefined ? d.challenger.avatarUrl : '/images/male-default.png'"/>
                                <b>{{ isMeChallenger(d) ? d.challengee.username : d.challenger.username }}</b>
                            </div>
                            <div class="status">
                                <div v-if="d.status == 'TIE'" class="text-primary">{{ $t('challenge.history_tie') }}</div>
                                <div v-else-if="(d.challenger.id == user.id && d.status == 'CHALLENGER_WON') || (d.challengee.id == user.id && d.status == 'CHALLENGEE_WON')" class="text-success">{{ $t('challenge.history_win') }} <i class="fas fa-check-circle"></i></div>
                                <div v-else class="text-danger">{{ $t('challenge.history_lose') }} <i class="fas fa-times-circle"></i></div>
                                <div>{{ isMeChallenger(d) ? d.challengerBalance.abbr(true) : d.challengeeBalance.abbr(true) }} <img src="/images/token.png"/></div>
                            </div>
                        </li>                        
                    </ul>
                    <div v-else-if="loaded" class="text-center">
                        <h3 class="text-primary mt-5 mb-3">{{ $t('challenge.history_no_data_title') }}</h3>
                        <p class="mb-5">{{ $t('challenge.history_no_data_subtitle') }}</p>
                        <img :src="`/images/theme/${user.mtsCustomer ? 'mts' : 'default'}/bear/challenges/bear-no-finished.png`" class="vh-40 mb-5" />
                        <b-button @click="hide" variant="success" type="button" size="lg">{{ $t('challenge.history_play_btn') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../api'

const ChallengeHistory = Vue.component('challenge-history', {
    data() {
        return {
            open: false,
            data: [],
            loaded: false,
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },


    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");
            this.loaded = false;

            api.finishedChallenges()
                .then(function (response) {
                    $this.data = response.data;
                    // document.querySelectorAll("#challengeHistortyPage .dataList")[0].scrollTop = 0;
                    $this.open = true;
                    $this.loaded = true;
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });

            this.open = true;
        },

        hide() {
            this.open = false;
            this.data = [];
            document.getElementById('loader').classList.remove("show");
        },  

        isMeChallenger(data){
            return (data.challenger != undefined && data.challenger.id == this.user.id);
        }
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    }
})

export default ChallengeHistory
</script>